'use client'

import { useRouter, useSearchParams } from 'next/navigation'
import { sortOptions } from '../constants'

export const SortSelectorClient = ({ initialSort }: SortSelectorClientProps) => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const handleSortChange = (newSort: string) => {
    const params = new URLSearchParams(searchParams.toString())
    if (newSort && newSort !== sortOptions.RELEVANCE) {
      params.set('sort', newSort)
    } else {
      params.delete('sort')
    }
    params.set('page', '1') // Reset to page 1
    router.push(`/blog/search?${params.toString()}`)
  }

  return (
    <div>
      <label htmlFor="sort" className="sr-only">
        Sort By
      </label>
      <p className="hidden md:block text-sm text-gray-500 mb-1">Sort By</p>
      <select
        id="sort"
        name="sort"
        value={initialSort || sortOptions.RELEVANCE}
        onChange={e => handleSortChange(e.target.value)}
        className="block w-full rounded-md border-0 py-2.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-vi-gray sm:text-lg/6"
      >
        <option value={sortOptions.RELEVANCE}>Relevance</option>
        <option value={sortOptions.DATE_ADDED_NEW_TO_OLD}>
          Date (Newest First)
        </option>
        <option value={sortOptions.DATE_ADDED_OLD_TO_NEW}>
          Date (Oldest First)
        </option>
      </select>
    </div>
  )
}

interface SortSelectorClientProps {
  initialSort: string
}

